// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorMessage{
    position: relative;
    margin: 0;
}

.errorMessage p{
    width: 100%;
    display: flex;
    justify-content: end;
    align-items:center;
    position: absolute;
    top: -15px;
    font-size: 13px;
}

.email_input{
    text-transform: lowercase;
}`, "",{"version":3,"sources":["webpack://./src/Components/Users/AddUser/AddUser.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".errorMessage{\n    position: relative;\n    margin: 0;\n}\n\n.errorMessage p{\n    width: 100%;\n    display: flex;\n    justify-content: end;\n    align-items:center;\n    position: absolute;\n    top: -15px;\n    font-size: 13px;\n}\n\n.email_input{\n    text-transform: lowercase;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
